import styled from 'styled-components';
import SahelShareIcon from '../../../../new-components/svg-icons/SahelShareIcon';
import { toast } from 'react-toastify';
import { useTranslation } from 'next-i18next';

const ShareButton = () => {
  const { t } = useTranslation('common');


  const handleClick = () => {
    const url = 'https://www.nawy.com/search?view=map';

    navigator.clipboard.writeText(url);
    toast.info(t('copied_to_clipboard'));
  };

  return (
    <Container onClick={handleClick}>
      <SahelShareIcon />
    </Container>
  );
};

const Container = styled.div`
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f1f3;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 360px;

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 40px;
    height: 40px;
  }
`;

export default ShareButton;
